<script>
import ListDefault from "../Utils/Page/ListDefault";

export default {
    name: "List",
    mixins: [ListDefault],
    data() {
        return {
            lang: this.$ml.get('pages.subscription_gift'),

            filter: {
                plan_id: { value: null, type: 'select', options: []},
                parent_id: { value: null, type: 'text'},
                user_id: { value: null, type: 'text'},
            },

            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'plan_id', is_sort: true, classes: 'text-l' },
                { key: 'parent_id', is_sort: true, classes: 'text-l' },
                { key: 'user_id', is_sort: true, classes: 'text-l' },
                { key: 'occasion_id', is_sort: true, classes: 'text-l' },
            ],

            tableBody: {
                parent_id: {
                    type: 'dictionary',
                    index: 'id',
                    local_index: 'parent_id',
                    label: 'name',
                    dictionary: 'user_id'
                },
                user_id: {
                    type: 'dictionary',
                    index: 'id',
                    local_index: 'user_id',
                    label: 'name',
                    dictionary: 'user_id'
                },
                plan_id: {
                    type: 'dictionary',
                    index: 'id',
                    local_index: 'plan_id',
                    label: 'title',
                    dictionary: 'plan_id'
                },
                occasion_id: {
                    type: 'dictionary',
                    index: 'id',
                    local_index: 'occasion_id',
                    label: 'name',
                    dictionary: 'occasion_id'
                },
            },

            apiList: this.$store.getters.getApiUrl('subscription_gift'),
            pageRoute: 'subscription_gift',
            pageRouteCreate: 'subscription_gift.create',
            pageRouteEdit: 'subscription_gift.edit',
        }
    },
    mounted() {
        this.getDictionaries().then(({data}) => {
            this.dictionaries = data.dictionaries

            for (let key in this.filter) {
                if (this.dictionaries[key]) {
                    this.filter[key].options = this.dictionaries[key]
                }
            }
        })
    }
}
</script>

<style scoped>

</style>
